<template>
  <div class="wl-results" v-if="doc">
    <results-bar :doc="doc" @loadSummary="loadSummary"></results-bar>
    <results-summary v-if="summary" :id="doc.id"></results-summary>
  </div>
</template>

<script>
import { ResultsBar, ResultsSummary } from "@/components/results/four-corners";

export default {
  name: "ResultFourCorners",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
    };
  },
  components: {
    ResultsBar,
    ResultsSummary,
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
  },
};
</script>
